export default "__VITE_ASSET__eyGh1H01__"